module.exports = __webpack_public_path__ + "static/media/twitter-icon.b0366469.svg";